var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatchFitness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 31,
    viewBox: "0 0 23 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 28.875C3.75 29.9297 4.57031 30.75 5.625 30.75H16.875C17.8711 30.75 18.75 29.9297 18.75 28.875V27.9375H3.75V28.875ZM18.75 2.625C18.75 1.62891 17.8711 0.75 16.875 0.75H5.625C4.57031 0.75 3.75 1.62891 3.75 2.625V3.5625H18.75V2.625ZM18.75 5.4375H3.75C1.64062 5.4375 0 7.13672 0 9.1875V22.3125C0 24.4219 1.64062 26.0625 3.75 26.0625H18.75C20.8008 26.0625 22.5 24.4219 22.5 22.3125V9.1875C22.5 7.13672 20.8008 5.4375 18.75 5.4375ZM16.7578 16.1602L11.7773 21.1406C11.6602 21.3164 11.4258 21.375 11.25 21.375C11.0156 21.375 10.7812 21.3164 10.6641 21.1406L5.68359 16.1602C4.21875 14.6953 4.33594 12.293 5.91797 10.9453C7.32422 9.77344 9.43359 9.94922 10.7227 11.2383L11.25 11.7656L11.7188 11.2383C13.0078 9.94922 15.1172 9.77344 16.5234 10.9453C18.1055 12.293 18.2227 14.6953 16.7578 16.1602Z",
    fill: "#959CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchFitness);
export default __webpack_public_path__ + "static/media/watchFitness.3835794f.svg";
export { ForwardRef as ReactComponent };